import React from 'react'
import styled from 'react-emotion'

import { colours } from '../../theme'

const Wrapper = styled('nav')`
	align-items: center;
	display: flex;
	justify-content: center;
`

const NavItem = styled('button')`
	background: #EDEDED;
	border: none;
	color: #111;
	margin: 0 0.5rem;
	padding: 0 1rem;
	transition: background 250ms linear;
	&:hover {
		background: #111;
		color: #fff;
	}
	&.active {
		background: ${colours.primary};
		color: #fff;
	}
`

const range = (from, to, step = 1) => {
	let i = from
	const range = []

	while (i <= to) {
		range.push(i)
		i += step
	}

	return range
}

class Pagination extends React.Component {
	constructor(props) {
		super(props)

		const { total, limit = 1 } = props

		this.limit = typeof limit === "number" ? limit : 1
		this.total = typeof total === "number" ? total : 0

		this.totalPages = Math.ceil(this.total /this.limit)

		this.state = { currentPage: 1 }
	}

	componentDidMount() {
		this.goToPage(1)
	}

	goToPage = page => {
		const { onPageChanged = f => f } = this.props

		const currentPage = Math.max(0, Math.min(page, this.totalPages))

		const paginationData = {
			currentPage,
			totalPages: this.totalPages,
			limit: this.limit,
			total: this.total
		}

		this.setState({ currentPage }, () => onPageChanged(paginationData))
	}

	handleClick = page => {
		this.goToPage(page)
	}

	fetchPageNumbers = () => {
		return range(1, this.totalPages)
	}

	render() {
		if (!this.total) return null
		if (this.totalPages === 1) return null

		const { currentPage } = this.state
		const pages = this.fetchPageNumbers()

		return (
			<Wrapper aria-label="Mandate Pagination">
				{pages.map(page => (
					<NavItem key={page} className={currentPage === page ? 'active' : null} onClick={() => {this.handleClick(page)}}><span className="sr-only">page </span>{page}</NavItem>
				))}
			</Wrapper>
		)
	}
}

export default Pagination
